



















import { InterventionApi } from "../../api/InterventionApi";
import DashboardTable from "../../core/Tables/DashboardTable.vue";
import { Intervention } from "../../models/Intervention";

export default {
    name: "EmployesHorsLigne",
    components: { DashboardTable },
    data() {
        return {
            employes: [],
            InterventionApi: new InterventionApi(),
        };
    },
    created() {
        let self = this;
        self.InterventionApi.getAlerts(
            Intervention.EAlertType.OfflineUsers
        ).then(function (res) {
            self.employes = res;
        });
    },
};
